import { render } from "./Scope.vue?vue&type=template&id=b80af7b2&scoped=true"
const script = {}

import "./Scope.vue?vue&type=style&index=0&id=b80af7b2&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80af7b2"]])

export default __exports__